function WorkWithUs({ content }) {
  return (
    <section className="work-with-us-section" id="contact">
      <img className="star-icon flower-one" src="/assets/images/flower-1.png" alt="star" aria-hidden="true" />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8" data-wow="fade-up">
            <p className="eybrow work-with-us-eybrow">
              <img className="star-icon" src="/assets/images/star.png" alt="star" aria-hidden="true" />
              {content.eyebrow}
            </p>

            <h2 className="work-with-us-title">
              {content.titleLines.map((line) => (
                <span key={line}>{line}</span>
              ))}
              <em>{content.accent}</em>
            </h2>

            <div className="row work-with-us-links">
              <div className="col-md-6">
                <a href={content.messageHref}>
                  {content.messageLabel}{" "}
                  <i className="fa-solid fa-arrow-right" />
                </a>
              </div>
              <div className="col-md-6">
                <a href={content.phoneHref}>{content.phoneLabel}</a>
              </div>
              <p className="work-with-us-description">{content.description}</p>
            </div>

            
          </div>
        </div>
      </div>
      <img className="star-icon flower-two" src="/assets/images/flower-2.png" alt="star" aria-hidden="true" />
    </section>
  );
}

export default WorkWithUs;
